import React, { FC, lazy } from "react";
import { SettingsPageLayout as Layout } from "Containers/Settings/SettingsHub/SettingsPageLayout";
import { lazyLoader } from "Service/loader";
const UpdateUserForm = lazyLoader(
  () => import("Containers/User/EditUserForm/EditUserForm")
);

export const EditUser: FC = () => {
  return (
    <Layout>
      <UpdateUserForm />
    </Layout>
  );
};
